import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { VimeoPlayerBlockConfig } from '@front-platform/content-builder';
import { vimeoPlayerBlockResolveConfig } from '@front-platform/content-builder';
import { Component, OnInit, input } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
export interface VimeoPlayerBlockRuntimeConfig {}

export type VimeoPlayerBlockConfigInput = Partial<
  Omit<VimeoPlayerBlockConfig, keyof VimeoPlayerBlockRuntimeConfig> & VimeoPlayerBlockRuntimeConfig
>;
export type VimeoPlayerBlockResolvedConfig = Omit<
  VimeoPlayerBlockConfig,
  keyof VimeoPlayerBlockRuntimeConfig
> &
  Partial<VimeoPlayerBlockRuntimeConfig>;
export interface VimeoPlayerBlockContract extends ConfigComponentContract<
  VimeoPlayerBlockConfigInput,
  VimeoPlayerBlockResolvedConfig
> {}

@Component({
  selector: 'app-vimeo-player-block',
  templateUrl: './vimeo-player-block.component.html',
  styleUrls: ['./vimeo-player-block.component.scss'],
  standalone: false,
})
export class VimeoPlayerBlockComponent implements OnInit, VimeoPlayerBlockContract {
  readonly config = input<VimeoPlayerBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    VimeoPlayerBlockConfig,
    VimeoPlayerBlockRuntimeConfig
  >(vimeoPlayerBlockResolveConfig, () => ({ config: this.config() }));
  get videoId(): string | undefined {
    return this.resolvedConfig()['video_id'] as unknown as string | undefined;
  }
  iframeSrc?: SafeResourceUrl;

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnInit(): void {
    const url = 'https://player.vimeo.com/video/' + this.videoId;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(VimeoPlayerBlockComponent, { 'keyAliases': {} });
